import { render, staticRenderFns } from "./SaveOnePdf.vue?vue&type=template&id=5c776bf9"
import script from "./SaveOnePdf.vue?vue&type=script&lang=js"
export * from "./SaveOnePdf.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports